"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function updateProgressMeasureForILT(iltState, states) {
    const sessionStates = states.filter(state => state.contentType === entity_1.ContentType.ILT_SESSION);
    const registeredSessionStates = sessionStates.filter(state => ((state.registerType === entity_1.SessionRegisterType.ENROLLED)
        || (state.registerType === entity_1.SessionRegisterType.ASSIGNED)));
    const completedRegisteredSessionStates = registeredSessionStates.filter(state => state.completionStatus ===
        entity_1.CompletionStatus.COMPLETE);
    iltState.progressMeasure = registeredSessionStates.length > 0 ?
        completedRegisteredSessionStates.length / registeredSessionStates.length : 0;
}
exports.updateProgressMeasureForILT = updateProgressMeasureForILT;
//# sourceMappingURL=updateProgressMeasureForILT.js.map